import { render } from "./ProductChart.vue?vue&type=template&id=528d217a&scoped=true"
import script from "./ProductChart.vue?vue&type=script&lang=js"
export * from "./ProductChart.vue?vue&type=script&lang=js"

import "./ProductChart.vue?vue&type=style&index=0&id=528d217a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\AirFryer\\AirFryer_Berater\\AirFryer_Kaufberatung\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528d217a"]])

export default __exports__